import { VSwitch } from 'vuetify/lib/components/VSwitch';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.canZoom || _vm.canLiveZoom)?_c('div',{staticClass:"d-flex align-center"},[(_vm.canZoom)?_c(VSwitch,{staticClass:"ma-0 mr-2",attrs:{"hide-details":"","label":_vm.$t('zoomControl')},on:{"change":_vm.toggleSlideZoom},model:{value:(_vm.slideZoom),callback:function ($$v) {_vm.slideZoom=$$v},expression:"slideZoom"}}):_vm._e()],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }